// GENERATED FILE - DO NOT MODIFY
export enum CatalogItemManagementMode {
    Serial = "3",
}

export let nameof = "CatalogItemManagementMode";
